<!--
 * @Description: 教职工详情 出国（境）进修学习
 * @Author: 张天伟
 * @Date: 2023-03-08 17:08:59
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:45:23
-->

<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="教职工" label-align="right" align="left" width="160px" span="2">{{item.xm}}</el-descriptions-item>
      <el-descriptions-item label="出国（境）日期" label-align="right" align="left" width="160px" span="2">{{item.cgrq}}</el-descriptions-item>
      <el-descriptions-item label="出国（境）目的" label-align="right" align="left" width="160px" span="2">{{item.cgmd}}</el-descriptions-item>
      <el-descriptions-item label="出国（境）国别" label-align="right" align="left" width="160px" span="2">{{item.cggbbt}}</el-descriptions-item>
      <el-descriptions-item label="所去单位英文名称" label-align="right" align="left" width="160px" span="2">{{item.sqdwywmc}}</el-descriptions-item>
      <el-descriptions-item label="所去单位中文名称" label-align="right" align="left" width="160px" span="2">{{item.sqdwzwmc}}</el-descriptions-item>
      <el-descriptions-item label="派出单位" label-align="right" align="left" width="160px" span="2">{{item.pcdw}}</el-descriptions-item>
      <el-descriptions-item label="团组名称" label-align="right" align="left" width="160px" span="2">{{item.tzmc}}</el-descriptions-item>
      <el-descriptions-item label="出国（境）经费来源" label-align="right" align="left" width="160px" span="2">{{item.cgjflybt}}</el-descriptions-item>
      <el-descriptions-item label="审批单位" label-align="right" align="left" width="160px" span="2">{{item.spdw}}</el-descriptions-item>
      <el-descriptions-item label="审批日期" label-align="right" align="left" width="160px" span="2">{{item.sprq}}</el-descriptions-item>
      <el-descriptions-item label="审批文号" label-align="right" align="left" width="160px" span="2">{{item.spwh}}</el-descriptions-item>
      <el-descriptions-item label="批准期限" label-align="right" align="left" width="160px" span="2">{{item.pzqx}}</el-descriptions-item>
      <el-descriptions-item label="学习工作内容" label-align="right" align="left" width="160px" span="2">{{item.xxgznr}}</el-descriptions-item>
      <el-descriptions-item label="学习工作成绩" label-align="right" align="left" width="160px" span="2">{{item.xxgzcj}}</el-descriptions-item>
      <el-descriptions-item label="应回国日期" label-align="right" align="left" width="160px" span="2">{{item.yhgrq}}</el-descriptions-item>
      <el-descriptions-item label="实回国日期" label-align="right" align="left" width="160px" span="2">{{item.shgrq}}</el-descriptions-item>
      <el-descriptions-item label="护照号/通行证号" label-align="right" align="left" width="160px" span="2">{{item.hzhtxzh}}</el-descriptions-item>
      <el-descriptions-item label="证件有效期" label-align="right" align="left" width="160px" span="4">{{item.zjyxq}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongchuguojinxiouxuexi/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
